// File: cgp-app-bar-menu-module.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP App Bar Menu module.
// Other Contributors:

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from "@angular/material/card";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { CgpAppBarMenuComponent } from "./cgp-app-bar-menu.component";
import { CgpUserProfileDialogModule } from "../../cgp-user-profile-dialog/cgp-user-profile-dialog.module";
import { CgpUserProfileDialogService } from "../../cgp-user-profile-dialog/cgp-user-profile-dialog.service";
import { PipesModule } from '../../pipes/pipes.module'

@NgModule({
    imports: [
        CommonModule, MatCardModule, MatMenuModule, MatButtonModule, MatIconModule, CgpUserProfileDialogModule,
        PipesModule,

    ],
    exports: [
        CgpAppBarMenuComponent
    ],
    declarations: [
        CgpAppBarMenuComponent
    ],
    providers: [
        CgpUserProfileDialogService
    ]
})
export class CgpAppBarMenuModule { }
